import React, { useMemo } from 'react';

import { ACCEPTED_IMAGE_TYPES, ACCEPTED_VIDEO_TYPES } from './helpers';

interface Props {
  disabled?: boolean;
  name: string;
  type: 'images' | 'videos';
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface HiddenFileInputRef {
  open: () => void;
  reset: () => void;
}

const HiddenFileInput = React.forwardRef<HiddenFileInputRef, Props>(({ type, disabled, name, onChange }) => {
  const acceptFiles = useMemo(() => {
    if (type === 'images') return ACCEPTED_IMAGE_TYPES.join(', ');

    return ACCEPTED_VIDEO_TYPES.join(', ');
  }, [type]);

  return <input hidden name={name} type="file" accept={acceptFiles} onChange={onChange} disabled={disabled} />;
});

export default HiddenFileInput;
